/**
 * Tokens an Approval step's notification email SUBJECT can inject. Authors type
 * them wrapped in `[[ ]]` (e.g. `[[order.purchase_order_number]]`); at send time
 * the backend substitutes values from the draft sales order (`order.*` — an
 * `ar_draft_sales_orders` row) and its customer (`customer.*` — the joined
 * `ar_customers` row). Unknown tokens are left as-is.
 *
 * Keep the token keys in sync with the backend resolver
 * (`renderApprovalSubjectTemplate`).
 */

export interface ApprovalSubjectToken {
  /** Token key, used inside `[[ ]]` (e.g. "order.purchase_order_number"). */
  token: string;
  /** Short human label for the insert UI. */
  label: string;
}

export const APPROVAL_SUBJECT_TOKENS: ApprovalSubjectToken[] = [
  { token: "order.purchase_order_number", label: "Order — PO number" },
  { token: "order.order_date", label: "Order — order date" },
  { token: "order.total_amount", label: "Order — total amount" },
  { token: "order.currency", label: "Order — currency" },
  { token: "customer.name", label: "Customer — name" },
  { token: "customer.contact_person", label: "Customer — contact person" },
];

/** Matches a `[[ token ]]` occurrence; capture group 1 is the token key. */
export const APPROVAL_SUBJECT_TOKEN_PATTERN = /\[\[\s*([\w.]+)\s*\]\]/g;
